export * from './valid-number.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/valid-number/index.ts